const icons = {
  // Tamaños
  /* 12px */
  xs: {
    width: '0.75rem',
    height: '0.75rem'
  },

  /* 16px */
  s: {
    width: '1rem',
    height: '1rem'
  },

  /* 20px */
  sm: {
    width: '1.25rem',
    height: '1.25rem'
  },

  /* 22px */
  smm: {
    width: '1.37rem',
    height: '1.37rem'
  },

  /* 24px */
  m: {
    width: '1.5rem',
    height: '1.5rem'
  },

  /* 36px */
  l: {
    width: '2.25rem',
    height: '2.25rem'
  },

  /* 60px */
  xl: {
    width: '3.75rem',
    height: '3.75rem'
  }
};

export default icons;
